import * as constAction from 'root/actionConstants';
import {Map, List, fromJS} from 'immutable';

var defaultState = Map({
  viaje: Map(),
  reserva: Map(),
  pasajero: Map(),
  cancelarId: false,
  reservaLlena: false,
  showListaReservas: false,
  reservasPrevias: List(),
  reservasPendientes: List(),
  reservasProbables: List()
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.RESERVAS_CLEAR: {
      if(action.payload === 'all')
      return defaultState;
      else if(defaultState.has(action.payload))
      return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad '+action.payload);
        return state;
      }
    }
    case constAction.RESERVAS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.VIAJES_STREAM_TO_STATE: {
      if (action.payload && action.payload.target && state.getIn(['viaje','id']) == action.payload.target) {
        return state.set('viaje', fromJS(Object.assign(state.get('viaje').toJS(), action.payload.data)));
      }
      return state;
    }
    case constAction.RESERVAS_DEL_PREVIA: {
      state = state.deleteIn(['reservasPrevias', state.get('reservasPrevias').findIndex( reserva => reserva.get('id') == action.payload)]);
      if(state.get('reservasPrevias').size == 0) state = state.set('showListaReservas', false);
      return state;
    }
    default: return state;
  }
}



// WEBPACK FOOTER //
// src/modules/reservas/reducer.js